// Import required functions and slices from external modules
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import cartReducer from "./cartSlice";

// Create a Redux store using the configureStore function
export const store = configureStore({
    // Provide an object mapping reducer names to their respective reducer functions
    reducer: {
        // Use the apiSlice.reducerPath as the key for the apiSlice.reducer
        [apiSlice.reducerPath]: apiSlice.reducer,
        // Assign the cartReducer to the cart key
        cart: cartReducer,
    },

    // Middleware configuration function
    middleware: (getDefaultMiddleware) => {
        // Return the default middleware array concatenated with the apiSlice middleware
        return getDefaultMiddleware().concat(apiSlice.middleware)
    }
})

// Export the configured store as the default export
export default store;
